/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 19:17:06
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace CompareNoticeDOI {
    export interface RowDataI {
        comparison_site: any;
        dispose_company: any;
        id: number;
        inform_number: string;
        initiator: string;
        sponsor_datetime: string;
        status: number;
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        end_time?: Integer;
        start_time?: Integer;
        status?: Integer;
    }

    export interface QueryDetailResultI {
        dispose_company: string;
        dispose_company_id: number;
        inform_number: string;
        initiator: string;
        sponsor_datetime: string;
        comparison_site: {
            data: {
                operational_equipment: string[];
                operational_content: string;
                operational_site: string;
                operational_id: Integer;
                affirm_cause: string;
                affirm_condition: number;
                affirm_datatime: string;
                affirm_people: string;
                dispose_condition: string
                dispose_datatime: string
                dispose_explain: string
                dispose_people: string
                dispose_people_id: number
            }[];
        };
    }

    export interface OperateParamsI {
        id?: Integer;
        comparison_site: any;
        dispose_company_id: Integer;
    }
}
export default class CompareNoticeApi {
    /**
     * 查询列表
     * @param {CompareNoticeDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: CompareNoticeDOI.QueryRowDataParamsI): Promise<ResultPageDo<CompareNoticeDOI.RowDataI[]>> {
        return Api.post('/ops/comparison_infrom/list/get', {
            status: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<CompareNoticeDOI.QueryDetailResultI>> {
        return Api.post('/ops/comparison_infrom/particulars/get', params);
    }
    /**
     * 新增
     * @param {CompareNoticeDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: CompareNoticeDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/comparison_infrom/add', data);
    }

    /**
     * 修改
     * @param {CompareNoticeDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: CompareNoticeDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/comparison_infrom/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/ops/comparison_infrom/batch/delete', data);
    }

    static async getCompany(device_ids: number[] = []): Promise<Result<{ account_name: string; id: number }[]>> {
        return Api.post('/ops/company_name/get', {device_ids});
    }
}
